import { URL, URL_INDIVIDUAL_WEIGHING } from '../store/index'

/**
 * Normaliza path da API: slash inicial e trailing slash antes da query string.
 * Evita 301 do Django/DRF (cache Redis só grava respostas 200).
 */
export function apiPath(path) {
  if (!path) return '/'
  const raw = path.startsWith('/') ? path : `/${path}`
  const qIndex = raw.indexOf('?')
  const pathname = qIndex === -1 ? raw : raw.slice(0, qIndex)
  const query = qIndex === -1 ? '' : raw.slice(qIndex + 1)
  const normalizedPath = pathname.endsWith('/') ? pathname : `${pathname}/`
  return query ? `${normalizedPath}?${query}` : normalizedPath
}

/** Monta URL absoluta a partir do baseURL configurado (HTTPS). */
export function apiUrl(path) {
  const base = (URL || 'https://api.pecsmart.cloud/').replace(/\/?$/, '/')
  const normalized = apiPath(path).replace(/^\//, '')
  return `${base}${normalized}`
}

/** Headers estáveis para bater com a chave Redis (path + query + Authorization). */
export function mergeApiHeaders(headers = {}) {
  return {
    Accept: 'application/json',
    ...headers,
  }
}

/** Normaliza payloads da API (array direto, paginação DRF ou chaves comuns). */
export function extractApiList(payload) {
  if (Array.isArray(payload)) return payload
  if (!payload || typeof payload !== 'object') return []
  if (Array.isArray(payload.results)) return payload.results
  if (Array.isArray(payload.batch_weights)) return payload.batch_weights
  if (Array.isArray(payload.data)) return payload.data
  return []
}

export const apiRoutes = {
  smartCamHome: (pk) => apiUrl(`sensors/report/data/home/smartcam/smartcam_pk=${pk}?format=json`),
  smartMicHome: (pk) => apiUrl(`sensors/report/data/home/smartmic/smartmic_pk=${pk}?format=json`),
  barnSensorsHome: (barnPk) => apiUrl(`sensors/report/home/barn=${barnPk}`),
  batchHomeByBarn: (barnPk) => apiUrl(`batches/report/home/barn=${barnPk}`),
  batchHomeByBatch: (batchPk) => apiUrl(`batches/report/home/batch=${batchPk}`),
  farmHomeByFarm: (farmPk) => apiUrl(`barns/report/home/farm=${farmPk}`),
  farmHomeByCompany: (companyPk) => apiUrl(`farms/report/home/company=${companyPk}`),
  siloLastProfileBySilo: (siloPk, startDate, endDate, siloDimensionsOnly = false) => {
    const params = new URLSearchParams()
    if (startDate && endDate) {
      params.set('start_date', startDate)
      params.set('end_date', endDate)
    }
    if (siloDimensionsOnly) {
      params.set('silo_dimensions_only', 'true')
    }
    const query = params.toString()
    let path = `silo_profiles/silo_last_profiles_by_silo/${siloPk}`
    if (query) {
      path += `?${query}`
    }
    return apiUrl(path)
  },
  siloSettings: (siloPk) => apiUrl(`silo_settings/?silo=${siloPk}`),
  // Endpoint dedicado (host/porta próprios, fora do baseURL principal) — ver VUE_APP_INDIVIDUAL_WEIGHING_URL.
  individualWeighingByBarn: (barnPk) => `${URL_INDIVIDUAL_WEIGHING.replace(/\/$/, '')}/${barnPk}`,
}
